import React from 'react';
import { Heart } from 'lucide-react';

export default function WelcomeScreen({ ownerName = 'Marc', year = '2025', onViewEntries, onCreateEntry }) {
  return (
    <div className="min-h-screen bg-gradient-to-br from-rose-50 via-white to-amber-50 flex items-center justify-center p-4">
      <div className="max-w-md w-full text-center">
        {/* Year Edition Badge */}
        <div className="inline-block bg-gray-900 text-white text-xs font-bold tracking-wider px-4 py-1.5 rounded-full mb-6">
          {year} EDITION
        </div>

        {/* Title - Owner's Name (handwritten) + Freundebuch (bold) */}
        <div className="mb-8">
          <h1 className="text-5xl mb-2" style={{ fontFamily: 'Caveat, cursive', color: '#3b82f6', fontWeight: 700 }}>
            {ownerName}'s
          </h1>
          <h2 className="text-4xl font-bold text-gray-900">
            Freundebuch
          </h2>
        </div>

        {/* Welcome Text */}
        <p className="text-gray-600 mb-10 px-6 leading-relaxed">
          Willkommen in meinem digitalen Freundebuch! Lerne meine Freunde kennen oder hinterlasse selbst einen Eintrag für die Ewigkeit.
        </p>

        {/* Buttons */}
        <div className="space-y-4 px-6">
          <button
            onClick={onViewEntries}
            className="w-full bg-gray-900 text-white py-4 rounded-2xl font-semibold hover:bg-gray-800 transition-colors shadow-lg"
          >
            Freundebuch ansehen
          </button>
          
          <button
            onClick={onCreateEntry}
            className="w-full bg-white border-2 border-gray-900 text-gray-900 py-4 rounded-2xl font-semibold hover:bg-gray-50 transition-colors"
          >
            Ins Freundebuch eintragen
          </button>
        </div>

        {/* Footer - Optional Privacy Link */}
        <div className="mt-12">
          <p className="text-xs text-gray-400">
            friends.jo23.eu - Privat
          </p>
        </div>
      </div>

      {/* Google Fonts Import für Caveat (handgeschriebene Schrift) */}
      <link
        href="https://fonts.googleapis.com/css2?family=Caveat:wght@400;700&display=swap"
        rel="stylesheet"
      />
    </div>
  );
}
